import {
    GET_STORES_REQUEST,
    GET_STORES_SUCCESS,
    GET_STORES_FAIL,
    GET_STORE_REQUEST,
    GET_STORE_SUCCESS,
    GET_STORE_FAIL,
    GET_ALL_STORES_REQUEST,
    GET_ALL_STORES_SUCCESS,
    GET_ALL_STORES_FAIL,
} from "../constants/storesConstants";

export const getStoresReducer = (state = {} , action) => {
    switch (action.type) {
        case GET_STORES_REQUEST:
            return { loading: true };
        case GET_STORES_SUCCESS:
            return { loading: false, stores: action.payload };
        case GET_STORES_FAIL:
            return { loading: false, error: action.payload };
        case GET_ALL_STORES_REQUEST:
            return { loading: true };
        case GET_ALL_STORES_SUCCESS:
            return { loading: false, allStores: action.payload };
        case GET_ALL_STORES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}

export const getStoreReducer = (state = {} , action) => {
    switch (action.type) {
        case GET_STORE_REQUEST:
            return { loading: true };
        case GET_STORE_SUCCESS:
            return { loading: false, store: action.payload };
        case GET_STORE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
}